class PickupAvailability extends window.HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const hasInitialContent = this.innerHTML.trim() !== "";
    if (hasInitialContent) {
      this.bindModalEvents();
    } else {
      this.fetchPickupAvailability();
    }
    this.listenForVariantChanges();
  }
  listenForVariantChanges() {
    const section = this.closest(".shopify-section");
    if (!section) return;
    const sectionId = section.id.replace("shopify-section-", "");
    if (!sectionId) return;
    const form = document.getElementById(`product-form-${sectionId}`);
    if (!form) return;
    const variantInput = form.querySelector('input[name="id"]');
    if (!variantInput) return;
    this.variantChangeHandler = () => {
      const newVariantId = variantInput.value;
      if (newVariantId) {
        this.fetchPickupAvailability(newVariantId);
      }
    };
    variantInput.addEventListener("change", this.variantChangeHandler);
  }
  disconnectedCallback() {
    if (this.variantChangeHandler) {
      const section = this.closest(".shopify-section");
      if (section) {
        const sectionId = section.id.replace("shopify-section-", "");
        const form = document.getElementById(`product-form-${sectionId}`);
        if (form) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput) {
            variantInput.removeEventListener("change", this.variantChangeHandler);
          }
        }
      }
    }
  }
  async fetchPickupAvailability(variantId) {
    if (!variantId) {
      variantId = this.getDefaultVariantId();
    }
    if (!variantId) {
      console.error("No variant ID available");
      return;
    }
    try {
      const productUrl = this.getProductUrl();
      if (!productUrl) {
        console.error("No product URL found");
        return;
      }
      const url = `${productUrl}?variant=${variantId}&section_id=pickup-availability`;
      const response = await fetch(url);
      if (!response.ok) {
        console.error("Failed to fetch pickup availability", response.status);
        return;
      }
      const html = await response.text();
      if (!html || html.trim() === "") {
        this.innerHTML = "";
        return;
      }
      this.innerHTML = html;
      this.bindModalEvents();
    } catch (error) {
      console.error("Error fetching pickup availability:", error);
    }
  }
  getProductUrl() {
    const section = this.closest(".shopify-section");
    if (section) {
      const variantPicker = section.querySelector("variant-radios, variant-selects");
      if (variantPicker && variantPicker.dataset.url) {
        return variantPicker.dataset.url;
      }
    }
    return window.location.pathname;
  }
  getDefaultVariantId() {
    const section = this.closest(".shopify-section");
    if (section) {
      const sectionId = section.id.replace("shopify-section-", "");
      const form = document.getElementById(`product-form-${sectionId}`);
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          return variantInput.value;
        }
      }
    }
    return null;
  }
  bindModalEvents() {
    const modalTemplate = this.querySelector("[data-pickup-modal-template]");
    if (!modalTemplate) return;
    const existingModal = document.body.querySelector(
      "[data-pickup-modal][data-pickup-availability-modal]"
    );
    if (existingModal) {
      existingModal.remove();
    }
    const modalContent = modalTemplate.content.cloneNode(true);
    const modal = modalContent.querySelector("[data-pickup-modal]");
    modal.setAttribute("data-pickup-availability-modal", "");
    document.body.appendChild(modal);
    const openButtons = this.querySelectorAll("[data-pickup-modal-open]");
    const closeButtons = modal.querySelectorAll("[data-pickup-modal-close]");
    openButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        modal.classList.remove("hidden");
        document.body.style.overflow = "hidden";
      });
    });
    closeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        modal.classList.add("hidden");
        document.body.style.overflow = "";
      });
    });
    const escapeHandler = (e) => {
      if (e.key === "Escape" && !modal.classList.contains("hidden")) {
        modal.classList.add("hidden");
        document.body.style.overflow = "";
      }
    };
    document.addEventListener("keydown", escapeHandler);
    this._modal = modal;
    this._modalCleanup = () => {
      document.removeEventListener("keydown", escapeHandler);
      if (modal && modal.parentNode) {
        modal.remove();
      }
    };
  }
}
window.customElements.define("pickup-availability", PickupAvailability);
